var variantNameElement = $(".product-form__option-name");

const languageRegex = /^[a-zA-ZäöüßÄÖÜ0-9 ]*$/;
const languageNoRegex = /[^a-zA-ZäöüßÄÖÜ0-9 ]/g
const arabicRegex = /[\u0600-\u06FF]/g;
const emojiRegex = /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{2763}]|[\u{2765}-\u{27BF}]|[\u{1F1E6}-\u{1F1FF}]|[\u{1F191}-\u{1F251}]|[\u{1F004}]|[\u{1F0CF}]|[\u{1F170}-\u{1F171}]|[\u{1F17E}-\u{1F17F}]|[\u{1F18E}]|[\u{3030}]|[\u{2B50}]|[\u{2B55}]|[\u{2934}-\u{2935}]|[\u{2B06}-\u{2B07}]|[\u{2B05}]|[\u{27A1}]|[\u{1F500}-\u{1F53D}]|[\u{1F54B}-\u{1F567}]/gu;
var formElement = document.querySelector(".product-form form");
formElement.additionalObject = ['', ''];
var MessageInput = $(".adp-item-message-content>input")
var AddToCartBtn = document.querySelector("#MainPaymentContainer #AddToCart")
var AddToCartStickyBtn = document.querySelector("#StickyAddToCart")
var BundleAddToCartBtn = document.querySelector(".bundle-form-atc")
var StickyAddToCartOverlay = document.querySelector("#StickyAddToCartOverlay")
var requiredFactorCount = window.Shopify.requiredFactorCount || 0;
const pslOptionYes = "نعم";
const pslOptionNo = "لا";
const pslOptionTitle = "Personalize";
const bpslOptionTitle = "Box Personalize";
const luxeBoxString = "طقم هدايا لوكس بوكس";
const standardboxString = "طقم صندوق هدايا";

// christmas
const christmasboxString = "طقم هدايا علبة عيد الميلاد";
//
var variantNameElementIndex = 0;
variantNameElement.each(function (index) {
  if ($(this).text() == `${pslOptionTitle}:` || $(this).text() == `${bpslOptionTitle}:`) {
    var that = this;
    let pslVariantValueElement = $(".product-form__option-value:eq(" + index + ")")
    let pslOptionElement = $(`.personalize-option input:eq(${variantNameElementIndex})`);
    let pslVariantOptionbox = pslVariantValueElement.parent().siblings(".block-swatch-list");

    if($(this).text() == `${bpslOptionTitle}:`){
      $(`input[value='${luxeBoxString}']`).on("click",function(){
        $(".personalize-container.box").show();//
        $(".xmas-box-remain-bar").hide();
      })
      $(`input[value='${standardboxString}']`).on("click",function(){
        pslVariantOptionbox.find(`input[value='${pslOptionNo}']`).click()
        $(".personalize-container.box").hide();
        $(".xmas-box-remain-bar").hide();
      })
      //christmas
      $(`input[value='${christmasboxString}']`).on("click",function(){
        pslVariantOptionbox.find(`input[value='${pslOptionNo}']`).click()
        $(".personalize-container.box").hide();
        $(".xmas-box-remain-bar").show();
      })
      //
    }
    //init 
    $(document).ready(function () {
      if(requiredFactorCount == 0){
        requiredFactorCount = window.Shopify.requiredFactorCount;
      }
      //ygh three bundle plugin
      let frequentBoughtTimer = null;
      let times1 = 0;
      frequentBoughtTimer = setInterval(() => {
        times1++
        if ($(".cbb-frequently-bought-add-button").length || times1 > 300) {
          $(".cbb-frequently-bought-add-button").css("pointer-events", "none")
          $(".cbb-frequently-bought-add-button").wrap("<div id='cbb-overlay' style='cursor:pointer;display:inline-block;'></div>")
          document.querySelector("#cbb-overlay").addEventListener("click", function () {
            var formPslRadioValue = document.forms[window.product_form_id][pslOptionTitle].value
            $(".cbb-frequently-bought-add-button").css("pointer-events", "auto")
            if (formPslRadioValue == pslOptionYes) {
              pslVariantOptionbox.find(`input[value='${pslOptionNo}']`).click();
              setTimeout(() => {
                $(".cbb-frequently-bought-add-button").click()
                $(".cbb-frequently-bought-add-button").css("pointer-events", "none")
              }, 500)
            }
            else {
              $(".cbb-frequently-bought-add-button").click()
              $(".cbb-frequently-bought-add-button").css("pointer-events", "none")
            }
          }, true);
          clearInterval(frequentBoughtTimer);
          frequentBoughtTimer = null;
        }
      }, 500)
    })
    //personalization input tip
    $(`.pslOption-input-text:eq(${variantNameElementIndex})`).on("input change paste", function () {
      let textContent = $(this).val();
      let characterLen = textContent.length;
      let previewBtn = $(this).closest(".personalize-container").find(".pslOption-input-text-preview-btn")
      let tipNoArabicWord = $(this).closest(".personalize-container").find(".personalize-name .tip-noArabicWord")
      let tipOnlyEG = $(this).closest(".personalize-container").find(".personalize-name .tip-onlyEG")
      let tipNoMore = $(this).closest(".personalize-container").find(".personalize-name .error-box.tip-nomore")
      let tipRequired =$(this).closest(".personalize-container").find(".personalize-name .error-box.tip-required")
      let tipNoArabicShow = false;
      if(tipNoArabicWord.length != 0){
        tipNoArabicShow = !tipNoArabicWord.hasClass("error-hidden")
      }
      let tipNoMoreShow = !tipNoMore.hasClass("error-hidden")
      let tipRequiredShow = !tipRequired.hasClass("error-hidden")
      let tipOnlyEGShow = !tipOnlyEG.hasClass("error-hidden")
      let AddToCartBtnDisabledAttr = AddToCartBtn.getAttribute("disabled")
      if(emojiRegex.test(textContent)){
        textContent = textContent.replace(emojiRegex, '')
        $(this).val(textContent)
      }
      if($(that).text() == `${bpslOptionTitle}:` && !languageRegex.test(textContent)){
        textContent = textContent.replace(languageNoRegex,'')
        if(!tipOnlyEGShow && characterLen != 0){
          tipOnlyEG.removeClass("error-hidden");
        }
        $(this).val(textContent)
      }else{
        if(tipOnlyEGShow){
          tipOnlyEG.addClass("error-hidden");
        }
      }
      if($(that).text() == `${pslOptionTitle}:` && arabicRegex.test(textContent)){
        textContent = textContent.replace(arabicRegex, '')
        if(!tipNoArabicShow && characterLen != 0){
          tipNoArabicWord.removeClass("error-hidden");
        }
        $(this).val(textContent)
      }else{
        if(tipNoArabicShow){
          tipNoArabicWord.addClass("error-hidden");
        }
      }

      characterLen = textContent.length;
      //input frame
      if (characterLen < 1 && !tipRequiredShow) {
        if(tipNoMoreShow){
          tipNoMore.addClass("error-hidden")
          if(requiredFactorCount!=0){
            requiredFactorCount--;
          }
        }
        tipRequired.removeClass("error-hidden")
        previewBtn.css("display","none")
        if ($(pslOptionElement).is(':checked')) {
          if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
            AddToCartBtn.setAttribute("disabled", "personalization");
            BundleAddToCartBtn.setAttribute("disabled", "personalization");
            AddToCartStickyBtn.setAttribute("disabled", "personalization");
            StickyAddToCartOverlay.style.display = "block"
            requiredFactorCount++;
            console.log("requiredFactorCount",requiredFactorCount)
          }
        }
      }
      else if (characterLen >= 1 && characterLen <= 12) {
        if (tipRequiredShow || tipNoMoreShow) {
          tipRequired.addClass("error-hidden");
          tipNoMore.addClass("error-hidden")
           if(requiredFactorCount!=0){
            requiredFactorCount--;
          }
          console.log("requiredFactorCount", requiredFactorCount)
        }
          previewBtn.css("display","inline-block")
          if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
            if (requiredFactorCount == 0) {
              AddToCartBtn.removeAttribute("disabled")
              BundleAddToCartBtn.removeAttribute("disabled")
              AddToCartStickyBtn.removeAttribute("disabled")
              StickyAddToCartOverlay.style.display = "none"
            }
          }
        // }
      }
      else if (characterLen > 12 && !tipNoMoreShow) {
        if(tipRequiredShow){
          tipRequired.addClass("error-hidden")
          if(requiredFactorCount!=0){
            requiredFactorCount--;
          }
        }
        $(this).val(textContent.trim());
        tipNoMore.removeClass("error-hidden");
        if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
          previewBtn.css("display","none")
          AddToCartBtn.setAttribute("disabled", "personalization");
          BundleAddToCartBtn.setAttribute("disabled", "personalization");
          AddToCartStickyBtn.setAttribute("disabled", "personalization");
          StickyAddToCartOverlay.style.display = "block"
          requiredFactorCount++;
          console.log("requiredFactorCount",requiredFactorCount)
        }
      }
    })
    $(".pslOption-input-text-preview-btn").on("click",function(){
        let previewInput = $(this).closest(".personalize-container").find(".pslOption-input-text")
        // previewBtn.css("display","inline-block")
        const userName = previewInput.val();
        Swal.fire({
            title: 'صندوقك المخصص',
            width:"45rem",
            html: '<canvas id="canvas" style="width:100%" width="1200" height="1200"></canvas>',
            customClass: {
                popup: 'box-custom-popup'
            },
            backdrop: 'rgba(0, 0, 0, 0.5)',
            showConfirmButton: false, 
            allowOutsideClick: true, 
            didOpen: () => {
                const canvas = document.getElementById('canvas');
                const ctx = canvas.getContext('2d');
                const img = new Image();
                
                img.src = 'https://cdn.shopify.com/s/files/1/0617/7652/7613/files/boxcustom-preview-bg.jpg?v=1728374401';
                img.onload = () => {
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    ctx.save();
                    var changeCW = canvas.width / 2 - 6;
                    var changeCH = canvas.height / 2 + 6;
                    
                    var endCCW = (canvas.width-changeCW)/2
                    var endCCWH = (canvas.height-changeCH)
                    
                    ctx.translate(changeCW, changeCH);
                    const angle = 16.5 * Math.PI / 180;
                    ctx.rotate(angle);
                    
                    var gradient = ctx.createLinearGradient(endCCW + endCCW*Math.sin(10 * Math.PI/180),0,endCCW-endCCW*Math.sin(15 * Math.PI/180) ,endCCWH/2+10);
                    gradient.addColorStop(0, '#8d4135');
                    gradient.addColorStop(0.35, '#dca295');
                    gradient.addColorStop(0.7, '#722c24');
                    
                    ctx.font = '52px Plantagenet Cherokee';
                    ctx.fillStyle = gradient
                    ctx.textAlign = 'center';
                    ctx.fillText(userName, 0,0);
                    ctx.restore();
                };
            }
        });
    })
    //init
    $(`.personalize-option:eq(${variantNameElementIndex}) input:radio`).click(function () {
      if ($(this).data("checked")) {
        $(this).data("checked", false)
        $(this).prop("checked", false)
        $(this).parent().find("input").trigger("change")
      } else {
        $(this).data("checked", true)
        $(this).prop("checked", true)
        $(this).parent().siblings().find("input").data("checked", false)
        $(this).parent().siblings().find("input").prop("checked", false)
         if(requiredFactorCount!=0){
            requiredFactorCount--;
          }
        console.log("requiredFactorCount",requiredFactorCount)
      }
    })
    //option bind to variant
    pslOptionElement.change(function (e) {
      let AddToCartBtnDisabledAttr = AddToCartBtn.getAttribute("disabled")
      const inputtext = $(this).closest(".personalize-container").find(".pslOption-input-text");
      const inputTextLen = inputtext.val().length;
      const inputHasArabic = !arabicRegex.test(inputtext.val())
      if($(this).is(":checked")) {
        pslVariantOptionbox.find(`input[value='${pslOptionYes}']`).click();
        $(this).closest(".personalize-container").find(".pslOption-input-text").attr("required", "true")
        $(this).closest(".personalize-container").find(".personalize-name").slideDown();
        $(this).closest(".personalize-container").find("input.form-name").attr("required", true)
        //
        $(this).closest(".personalize-container").find(".psl-tip-properties").val(pslOptionYes)
        //
        $(this).closest(".personalize-container").find(".pslOption-input-text").attr("form", window.product_form_id);
        $(this).closest(".personalize-container").find(".psl-tip-properties").attr("form", window.product_form_id);
        //
          requiredFactorCount++;
          console.log("requiredFactorCount",requiredFactorCount)
        if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
          AddToCartBtn.setAttribute("disabled", "personalization");
          BundleAddToCartBtn.setAttribute("disabled", "personalization");
          AddToCartStickyBtn.setAttribute("disabled", "personalization");
          StickyAddToCartOverlay.style.display = "block"
        }
      } else {
        $(this).closest(".personalize-container").find(".pslOption-input-text").removeAttr("required")
        pslVariantOptionbox.find(`input[value='${pslOptionNo}']`).click();
        $(this).closest(".personalize-container").find(".personalize-name").slideUp();
        $(this).closest(".personalize-container").find("input.form-name").removeAttr("required")
        $(this).closest(".personalize-container").find(".pslOption-input-text").val("");
        $(this).closest(".personalize-container").find(".pslOption-input-text").trigger("input")
        //
        $(this).closest(".personalize-container").find(".psl-tip-properties").val(pslOptionNo)
        //
        $(this).closest(".personalize-container").find(".pslOption-input-text").removeAttr("form")
        $(this).closest(".personalize-container").find(".psl-tip-properties").removeAttr("form")
        //
        
        if(inputTextLen>0 && inputTextLen <=12 && !inputHasArabic){

        }else{
           if(requiredFactorCount!=0){
            requiredFactorCount--;
          }
          console.log("requiredFactorCount",requiredFactorCount)
        }
        if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
          if (requiredFactorCount == 0) {
            AddToCartBtn.removeAttribute("disabled")
            BundleAddToCartBtn.removeAttribute("disabled")
            AddToCartStickyBtn.removeAttribute("disabled")
            StickyAddToCartOverlay.style.display = "none"
          }
        }
      }
    })

    // Variant bind to option
    pslVariantOptionbox.find(`input[value='${pslOptionNo}']`).click(function () {
      if ($(pslOptionElement).is(":checked")) {
        $(pslOptionElement).click();
      }
    });
    pslVariantOptionbox.find(`input[value='${pslOptionYes}']`).click(function () {
      if (!$(pslOptionElement).is(":checked")) {
        $(pslOptionElement).click();
      }
    });
    variantNameElementIndex++
  }
})


///////////////////////////////////christmas
var productList = {
  "3D Gift Message Card": {
    handle: 'personalized',
    "Blush": { id: "42536002617395", name: "أحمر خدود" },
    "Ether": { id: "42536002879539", name: "الأثير" },
    "Xmas":{ id: "42748341125171", name: "عيد الميلاد" }
  },
  "Additional Daycare Labels": {
    handle: 'sticky-labels',
    "70 Labels": { id: "44703699435773", name: "70 Labels" },
    "280 Labels": { id: "44703699370237", name: "280 Labels" }
  }
}

function getCurrency(currencyTemp) {
  return (0).toLocaleString(
    "en-us",
    {
      style: 'currency',
      currency: currencyTemp,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  ).replace(/\d/g, '').trim()
}
var currency = getCurrency(window.Shopify.currency.active);
$(".additional-product-wrapper input:radio").click(function () {
  if ($(this).data("checked")) {
    $(this).data("checked", false)
    $(this).prop("checked", false)
    //
    $(this).removeAttr("checked")
    $(this).parent().find("input").trigger("change")
    if($(".additional-product-wrapper input:checkbox").data("checked")){
      $(".additional-product-wrapper input:checkbox").click();
    }
  } else {
    $(this).data("checked", true)
    $(this).prop("checked", true)
    //
    $(this).attr("checked", true)
    $(this).parent().siblings().find("input").data("checked", false)
    $(this).parent().siblings().find("input").prop("checked", false)
    $(this).parent().siblings().find("input").removeAttr("checked")
  }
})
$(".additional-product-wrapper input:checkbox").click(function () {
  let inputContent = $(this).closest("label").find(".adp-item-message-content");
  let adpitemContent = $(this).parent().siblings('.adp-item-content')
  let tipNoMore = $(".adp-item-message-content .error-box.tip-nomore")
  let tipNoMoreShow = !tipNoMore.hasClass("error-hidden")
  let AddToCartBtnDisabledAttr = AddToCartBtn.getAttribute("disabled")
  if ($(this).data("checked")) {
    $(this).data("checked", false)
    $(this).prop("checked", false)
    //
    inputContent.slideUp();
    // inputContent.find("input.input-text").removeAttr("required")
    //
    adpitemContent.find("input:radio[checked]").click()
    if(tipNoMoreShow){
       if(requiredFactorCount!=0){
            requiredFactorCount--;
          }
      if (requiredFactorCount == 0) {
        AddToCartBtn.removeAttribute("disabled")
        BundleAddToCartBtn.removeAttribute("disabled")
        AddToCartStickyBtn.removeAttribute("disabled")
        StickyAddToCartOverlay.style.display = "none"
      }
    }

    window.Shopify.SeletedMessageCard.price = 0;
    $(document).trigger("card:changed",{});
  } else {
    $(this).data("checked", true)
    $(this).prop("checked", true)
    //
    // inputContent.find("input.input-text").attr("required", "true")
    inputContent.slideDown();
    //
    if(!adpitemContent.find('input[checked]').length){
      adpitemContent.find('input:radio')[0].click();
      
    if(tipNoMoreShow){
      if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
        AddToCartBtn.setAttribute("disabled", "personalization");
        BundleAddToCartBtn.setAttribute("disabled", "personalization");
        AddToCartStickyBtn.setAttribute("disabled", "personalization");
        StickyAddToCartOverlay.style.display = "block"
        requiredFactorCount++;
        console.log("requiredFactorCount",requiredFactorCount)
      }
    }
  }
  }
})
$(".adp-item-swatch input").change(function () {
  let AddToCartBtnDisabledAttr = AddToCartBtn.getAttribute("disabled")
  if ($(this).attr("checked")) {
    var price = window.Shopify.Price[$(this).val()]
    window.Shopify.SeletedMessageCard = {
      price:price,
      id:productList[this.name][$(this).val()]["id"]
    };
    $(document).trigger("card:changed",{});
    var name = productList[this.name][$(this).val()]["name"]
    if (price) {
      $(this).closest(".additional-product-wrapper").find(".adp-item-title-value").html(name + " | " + currency + price)
    }
    else {
      $(this).closest(".additional-product-wrapper").find(".adp-item-title-value").html(name)
    }
    if (this.name == "3D Gift Message Card") {
      formElement.additionalObject[0] = { id: productList[this.name][$(this).val()]["id"], properties: {} }
      if(MessageInput.val()){
        formElement.additionalObject[0].properties["الرسالة"] = MessageInput.val()
      }
    } else {
      formElement.additionalObject[1] = { id: productList[this.name][$(this).val()]["id"] }
    }
  }
  else {
    $(this).closest(".additional-product-wrapper").find(".adp-item-title-value").html("")
    if (this.name == "3D Gift Message Card") {
      formElement.additionalObject[0] = "";
      if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
        
        if (requiredFactorCount == 0) {
          AddToCartBtn.removeAttribute("disabled")
          BundleAddToCartBtn.removeAttribute("disabled")
          AddToCartStickyBtn.removeAttribute("disabled")
          StickyAddToCartOverlay.style.display = "none"
        }
      }
    } else {
      formElement.additionalObject[1] = "";
    }

  }
})
$(".adp-item-message-content>input").on("input paste", function () {
  let characterLen = $(this).val().length;
  if(emojiRegex.test($(this).val())){
    let tempText = $(this).val().replace(emojiRegex, '')
    $(this).val(tempText)
  }
  if(characterLen < 1){
    delete formElement.additionalObject[0].properties["الرسالة"];
  }else{
    formElement.additionalObject[0].properties["الرسالة"] = $(this).val();
  }
  let tipNoMore = $(".adp-item-message-content .error-box.tip-nomore")
  let tipRequired = $(".adp-item-message-content .error-box.tip-required")
  let tipNoMoreShow = !tipNoMore.hasClass("error-hidden")
  let tipRequiredShow = !tipRequired.hasClass("error-hidden")
  let AddToCartBtnDisabledAttr = AddToCartBtn.getAttribute("disabled")
  if (characterLen < 1 && !tipRequiredShow) {
    tipRequired.removeClass("error-hidden")
    tipNoMore.addClass("error-hidden")
  }
  else if (characterLen >= 1 && characterLen <= 60 && (tipRequiredShow || tipNoMoreShow)) {
    if(tipNoMoreShow){
      tipNoMore.addClass("error-hidden")
       if(requiredFactorCount!=0){
            requiredFactorCount--;
          }
      console.log("requiredFactorCount",requiredFactorCount)
    }else if(tipRequiredShow){
      tipRequired.addClass("error-hidden");
    }
    if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
      if (requiredFactorCount == 0) {
        AddToCartBtn.removeAttribute("disabled")
        BundleAddToCartBtn.removeAttribute("disabled")
        AddToCartStickyBtn.removeAttribute("disabled")
        StickyAddToCartOverlay.style.display = "none"
      }
    }
  }
  else if (characterLen > 600 && !tipNoMoreShow) {
    if(!tipNoMoreShow){
      tipNoMore.removeClass("error-hidden");
      tipRequired.addClass("error-hidden")
      requiredFactorCount++;
      console.log("requiredFactorCount",requiredFactorCount)
    }
    if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
      AddToCartBtn.setAttribute("disabled", "personalization")
      BundleAddToCartBtn.setAttribute("disabled", "personalization");
      AddToCartStickyBtn.setAttribute("disabled", "personalization");
      StickyAddToCartOverlay.style.display = "block"
    }
  }
})
//msg card
$(".msg-item-message-content>input").on("input paste", function () {
  if(!formElement.properties){
    formElement.properties={};
  }
  let characterLen = $(this).val().length;
  if(emojiRegex.test($(this).val())){
      let tempText = $(this).val().replace(emojiRegex, '')
      $(this).val(tempText)
  }
  let tipNoMore = $(".msg-item-message-content .error-box.tip-nomore")
  let tipRequired = $(".msg-item-message-content .error-box.tip-required")
  let tipNoMoreShow = !tipNoMore.hasClass("error-hidden")
  let tipRequiredShow = !tipRequired.hasClass("error-hidden")
  let AddToCartBtnDisabledAttr = AddToCartBtn.getAttribute("disabled")
  if (characterLen < 1 && !tipRequiredShow) {
      tipRequired.removeClass("error-hidden")
      tipNoMore.addClass("error-hidden")
  }
  else if (characterLen >= 1 && characterLen <= 60 && (tipRequiredShow || tipNoMoreShow)) {
      if(tipNoMoreShow){
      tipNoMore.addClass("error-hidden")
      if(requiredFactorCount!=0){
              requiredFactorCount--;
          }
      console.log("requiredFactorCount",requiredFactorCount)
      }else if(tipRequiredShow){
      tipRequired.addClass("error-hidden");
      }
      if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
      if (requiredFactorCount == 0) {
          AddToCartBtn.removeAttribute("disabled")
          AddToCartStickyBtn.removeAttribute("disabled")
          StickyAddToCartOverlay.style.display = "none"
      }
      }
  }
  else if (characterLen > 60 && !tipNoMoreShow) {
      if(!tipNoMoreShow){
      tipNoMore.removeClass("error-hidden");
      tipRequired.addClass("error-hidden")
      requiredFactorCount++;
      console.log("requiredFactorCount",requiredFactorCount)
      }
      if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
      AddToCartBtn.setAttribute("disabled", "personalization")
      AddToCartStickyBtn.setAttribute("disabled", "personalization");
      StickyAddToCartOverlay.style.display = "block"
      }
  }
})